import React from 'react';

import { Container, Image, Table } from 'react-bootstrap';
import { LightboxWrapper } from '..';

import "./CaptionedImage.css";


interface CaptionedImageProps {
    imageSrc: string;
    altText: string;
    showTitle?: boolean;
    captions?: string[];
    children?: React.ReactNode[];
};

const CaptionedImage = ({
    imageSrc,
    altText,
    showTitle = false,
    captions,
    children,
}: CaptionedImageProps): JSX.Element => {
    return (
        <Container className="captioned-image-container p-0 pb-3">
            <Table bordered variant='dark' >
                <tbody>
                    {showTitle && (
                        <tr>
                            <td>
                                <strong className='center'>{altText}</strong>
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td className='p-0'>
                            <LightboxWrapper>   
                                <Image 
                                    src={imageSrc}
                                    alt={altText}
                                    className="caption-image"
                                />
                            </LightboxWrapper>
                        </td>
                    </tr>
                    {children && children.map((child, index) => (
                        <tr key={index}>
                            <td>
                                {child}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
}

export { CaptionedImage };